import appResources from "./src/AppResources";
import {
    AppResource,
    AppResourceCollection,
    AppResourceSearch,
    ApiFieldset,
    ApiFilter,
    ApiResponse,
    Engine,
    Env,
    Logger,
} from "ss-js-engine";


Engine.config({
    appResources: appResources
});

export {
    AppResource,
    AppResourceCollection,
    AppResourceSearch,
    ApiFieldset,
    ApiFilter,
    ApiResponse,
    Engine,
    Env,
    Logger,
}
